import React from 'react';
import { ArrowButtonProps } from './types';
import { ReactComponent as ArrowLeft } from '../../../assets/arrow_left.svg';
import { ReactComponent as ArrowLeftDisabled } from '../../../assets/arrow_left_disabled.svg';
import { ReactComponent as ArrowRight } from '../../../assets/arrow_right.svg';
import { ReactComponent as ArrowRightDisabled } from '../../../assets/arrow_right_disabled.svg';
import { ArrowButtonDisable, ArrowButtonEnable } from './styles';

/**
 *
 * @param direction Direction of the arrow
 * @param disabled If 'true' the button won't be clickable
 * @param onClick Button OnClick method
 * @param dataTestId Id for tests
 *
 */

const ArrowButton: React.FC<ArrowButtonProps> = ({
  direction = 'left',
  disabled = false,
  onClick,
  dataTestId,
}) => (
  <>
    {disabled && (
      <ArrowButtonDisable data-testid={dataTestId}>
        {direction === 'left' ? <ArrowLeftDisabled /> : <ArrowRightDisabled />}
      </ArrowButtonDisable>
    )}
    {!disabled && (
      <ArrowButtonEnable onClick={onClick} data-testid={dataTestId} role="presentation">
        {direction === 'left' ? <ArrowLeft /> : <ArrowRight />}
      </ArrowButtonEnable>
    )}
  </>
);

export default ArrowButton;
